import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { getOverviewSref, NavigationOptions } from 'components/navigation/shared/states';
import { CurrentUserService } from 'services/currentUser';
import { getPoliciesSref } from 'components/navigation/shared/states';
import { getActionableCustomerPolicyInfos } from 'utilities/policyInfosHelper';

const module = angular.module('mobile-navigation', ['ui.router']);

interface MobileNavigationController extends angular.IStrictController {
    active: boolean;
    open(): void;
    close(): void;
    getPoliciesSref(): string;
    navigationList: NavigationOptions;
}

module.component('mobileNavigation', {
    template: template,
    controller: function(
        this: MobileNavigationController,
        $stateParams: StateParams,
        currentUserService: CurrentUserService
    ) {
        'ngInject';

        this.$onInit = () => {
            this.active = false;

            this.open = () => {
                this.active = true;
            };

            this.close = () => {
                this.active = false;
            };

            this.getPoliciesSref = getPoliciesSref;

            currentUserService.getDisplayOrderedCustomerPolicyInfos().then((policyInfos) => {
                const customerPolicyInfosWithIndexes = currentUserService.getIndexedCustomerPolicyInfos(policyInfos);
                const actionableCustomerPolicyInfos = getActionableCustomerPolicyInfos(customerPolicyInfosWithIndexes);
                this.navigationList = actionableCustomerPolicyInfos.map((policyInfo) => {
                    return {
                        label: policyInfo.property_data.address.street,
                        sref: getOverviewSref(policyInfo.$policyIndex)
                    };
                });
            });
        };
    }
});

export { module };
